import React from "react";

/**
 * RowHeader
 * Leftmost <th> of each row — the 1-based row number plus a row-resize
 * handle.  The TH itself carries sticky-left positioning; the visible
 * label is wrapped in a flex span so it can stay vertically centred
 * inside the row's height (see GridCell.jsx for the full reasoning on
 * why visible content lives in an inner element rather than directly
 * on the TH).
 */
function RowHeader({ rowIndex, rowHeight, className, style, onClick, onContextMenu, onStartResize }) {
  return (
    <th
      className={className}
      style={{ height: rowHeight + "px", ...style }}
      onClick={onClick}
      onContextMenu={onContextMenu}
    >
      <span
        className="simple-excel-row-header-content"
        style={{ height: rowHeight + "px" }}
      >
        {rowIndex + 1}
      </span>
      <span
        className="row-resize-handle"
        onMouseDown={(event) => onStartResize("row", rowIndex, event)}
      />
    </th>
  );
}

export default React.memo(RowHeader);
